import React from 'react';

import { useServiceError } from '@/hooks';

import { useRouteMatch } from 'react-router';
import { queryClient } from '@/Root';
import { QuotationSupplier } from '@/core/domain/stock/Quotations/Quotations.types';

import SuppliersSelectedModal from '@/components/_common/SuppliersSelectedModal';
import { useQuotationSuppliersSend } from '@/core/domain/stock/QuotationsSuppliers/QuotationsSuppliers.hooks';

interface Props {
  visible: boolean;
  handleVisible: () => void;
  currentAddedQuotationSuppliers?: QuotationSupplier[];
}

const CreateQuotationSupplierModal = ({
  visible,
  handleVisible,
  currentAddedQuotationSuppliers,
}: Props) => {
  const { quotationId } = useRouteMatch<{ quotationId: string }>().params;

  const mutation = useQuotationSuppliersSend();

  const handleOk = async (suppliers?: number[]) => {
    if (suppliers?.length) {
      const suppliersSend = suppliers?.filter(
        (supplier) =>
          !currentAddedQuotationSuppliers
            ?.map((quotation) => quotation.supplierId)
            .includes(supplier),
      );
      await mutation.mutateAsync({
        quotationId: Number(quotationId),
        supplierIds: suppliersSend,
      });

      await queryClient.refetchQueries([
        'quotations',
        quotationId,
        'suppliers',
      ]);

      handleCancel();
    }
  };

  useServiceError(mutation.error);

  const handleCancel = () => {
    handleVisible();
  };

  return (
    <SuppliersSelectedModal
      visible={visible}
      handleVisible={handleCancel}
      finishCallback={handleOk}
      selectSuppliersIds={currentAddedQuotationSuppliers?.map(
        (quotation) => quotation.supplierId,
      )}
    />
  );
};

export default CreateQuotationSupplierModal;
